import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import {BrowserRouter, Route ,Link } from "react-browser-router";
import { withStyles } from '@material-ui/core/styles';
import Header from '../general/Header'
import QuizDrawer from './QuizDrawer'
import YouCannotTakeItTwice from './YouCannotTakeItTwice'

import { QUIZ_START_URL } from '../../client_url_constant'
import { Base64 } from '../../modules/util'

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
  },
  input: {
    display: 'none',
  },
  description :{
    position: 'relative',
    width:1000,
    height:600,
  }
});

class Quiz extends Component {
  constructor(props) {
    super(props)
    this.state = {
      login : true,
      started: false,
      hasDone: false,
      firstTime:true,
      startDate:null,
      nameInputed: false,
      name: "",
    }
    this.startQuiz = this.startQuiz.bind(this)
    this.finishQuiz = this.finishQuiz.bind(this)
    this.NameInputHandler = this.NameInputHandler.bind(this)
  }

  componentWillMount() {
    // エンコードされたEmailをURLから取得し、取り除く
    if (!window.location.search && !sessionStorage.getItem('ad_tst_ref')) {
      window.location.href = "/accessdenied"
    };

    const encodedEmail = window.location.search.substring(1);

    sessionStorage.setItem('ad_tst_ref', encodedEmail);
    window.history.replaceState(null, '', window.location.href.split('?')[0]);
  }

    async  startQuiz() {
      this.setState({
      started: true,
    })

    const encodedEmail = sessionStorage.getItem('ad_tst_ref');
    const email = Base64.decode(encodedEmail)

    const name = this.state.name
    let body = JSON.stringify({
      email,
      name,
      startDate:new Date()
    });
    let method = "POST";
    let headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    };
    let firstTime
    try {
      const res = await fetch(QUIZ_START_URL, {method, headers, body});
      const json  = await res.json()

      firstTime = json.firstTime
    } catch (err) {
      console.log(err);
      this.setState({
        firstTime:false,
      })
    }
    this.setState({ firstTime })
  }
  finishQuiz() {
      this.setState({
      hasDone: true,
    })
  }

  NameInputHandler(name) {
    this.setState({
      name: name,
    })
  }



  render(){

    let mainContent = (this.state.firstTime)?
    <QuizDrawer started={this.state.started} hasDone={this.state.hasDone} finishFunk={this.finishQuiz} clickFunc={this.startQuiz} NameInputHandler={this.NameInputHandler} startDate={this.state.startDate}/>
    :
    <YouCannotTakeItTwice />

  return (
    <div>
      <Header login={this.state.login} />
      {mainContent}
    </div>
  );}
}


Quiz.propTypes = {
  classes: PropTypes.object.isRequired,
  //PropTypes.object.isRequired,
};

export default withStyles(styles)(Quiz);



// WEBPACK FOOTER //
// ./src/components/quiz/QuizMain.js